import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = { class: "flex items-center h-full" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "flex items-center h-full space-x-3" }
const _hoisted_5 = ["autocomplete", "id", "type", "placeholder", "value", "min", "max", "readonly", "disabled", "step"]
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-3 pr-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "p-0 mt-2 mb-1 text-sm text-red-400"
}

import { ref, onMounted, watch, computed } from "vue";
	import { makeFakeID } from "@/utils";
	
export default /*#__PURE__*/_defineComponent({
  __name: 'InputGroupTag',
  props: {
		icon: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "Change the placeholder",
		},
		label: {
			type: String,
			default: "",
		},
		css: {
			type: String,
			default: "",
		},
		type: {
			type: String,
			default: "email",
		},
		autocomplete: {
			type: String,
			default: "off",
		},
		error: {
			type: String,
			default: "",
		},
		min: {
			type: String,
			default: "",
		},
		max: {
			type: String,
			default: "",
		},
		name: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		readonly: {
			type: Boolean,
			default: false,
		},
	},
  emits: ["model", "validate", "cancel"],
  setup(__props, { emit: __emit }) {

	const emit = __emit;

	const inputTag = ref<any>(null);
	const inputTagID = ref(makeFakeID(5));
	const currentValue = ref("");
	const originalValue = ref("");

	const props = __props;

	const hasChanged = computed(() => currentValue.value !== originalValue.value);

	const onInput = (e: Event) => {
		const val = (e.target as HTMLInputElement).value;
		currentValue.value = val;
		emit("model", val);
	};

	const handleValidate = () => {
		originalValue.value = currentValue.value;
		emit("validate", { value: currentValue.value, name: props.name } );
	};

	const handleCancel = () => {
		currentValue.value = originalValue.value;
		emit("cancel", { value: originalValue.value, name: props.name });
	};

	watch(
		() => props.value,
		(newVal) => {
			currentValue.value = newVal;
			// originalValue.value = newVal;
		},
		{ immediate: true }
	);

	onMounted(async () => {
		inputTag.value = await document.querySelector("input[id=" + inputTagID.value + "]");
		originalValue.value = props.value;
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
				__props.css,
				'flex bg-gray-600 rounded-md justify-between pl-4 h-10 items-center',
			])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.icon != '')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "w-6 h-6 bg-no-repeat bg-cover",
              style: _normalizeStyle({
						backgroundImage: 'url(' + (__props.icon == '' ? '/media/icons/user-icon.svg' : __props.icon) + ')',
					})
            }, null, 4))
          : _createCommentVNode("", true),
        _createElementVNode("label", {
          class: "py-1 pr-2",
          for: inputTagID.value
        }, _toDisplayString(__props.label), 9, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          autocomplete: __props.autocomplete,
          id: inputTagID.value,
          type: __props.type,
          class: "bg-[#19202a] h-full outline-none px-2",
          placeholder: __props.placeholder,
          value: currentValue.value,
          min: __props.min,
          max: __props.max,
          readonly: __props.readonly,
          disabled: __props.disabled,
          onInput: onInput,
          step: __props.type === 'datetime-local' || 'time' ? '1' : undefined
        }, null, 40, _hoisted_5),
        (hasChanged.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: handleValidate,
                class: "text-green-400 hover:text-green-600"
              }, _hoisted_8),
              _createElementVNode("button", {
                onClick: handleCancel,
                class: "text-red-400 hover:text-red-600"
              }, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})